module.exports = __webpack_public_path__ + "img/powered-new-logo.7be6f902.svg";